import { useEffect, useRef } from "react";

/* ─── Vertical divider ─── */
export const Divider = ({ t }) => (
  <div
    className="flex-shrink-0"
    style={{
      width: 1,
      height: 24,
      background: t.divider,
      opacity: 0.6,
    }}
  />
);

/* ─── Icon button ─── */
export const IconBtn = ({ active, onClick, title, children, t }) => (
  <button
    title={title}
    onClick={onClick}
    className="relative flex items-center justify-center w-8 h-8 rounded-lg transition-all duration-200"
    style={{
      background: active ? t.activeBg : "transparent",
      border: active ? `1px solid ${t.activeBorder}` : "1px solid transparent",
    }}
    onMouseEnter={(e) => {
      if (!active) {
        e.currentTarget.style.background = t.hoverBg;
        e.currentTarget.style.border = `1px solid ${t.hoverBorder}`;
        e.currentTarget.style.boxShadow = t.hoverBtnShadow;
      }
    }}
    onMouseLeave={(e) => {
      if (!active) {
        e.currentTarget.style.background = "transparent";
        e.currentTarget.style.border = "1px solid transparent";
        e.currentTarget.style.boxShadow = "none";
      }
    }}
  >
    {children}
  </button>
);

/* ─── Dropdown menu ─── */
export const DropUp = ({ isOpen, onClose, trigger, children, t }) => {
  const ref = useRef(null);
  useEffect(() => {
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) onClose();
    };
    if (isOpen) document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, [isOpen, onClose]);

  return (
    <div ref={ref} className="relative">
      {trigger}
      {isOpen && (
        <div
          className="absolute top-full left-0 mt-2 w-[200px] rounded-lg overflow-hidden z-50"
          style={{
            background: t.dropBg,
            border: `1px solid ${t.dropBorder}`,
            boxShadow: t.dropShadow,
          }}
        >
          <div className="py-1">{children}</div>
        </div>
      )}
    </div>
  );
};

export const DropUpItem = ({ selected, onClick, icon: Icon, children, t }) => (
  <button
    onClick={onClick}
    className="w-full text-left px-3 py-1.5 flex items-center gap-2 text-xs transition-colors"
    style={{
      cursor: "pointer",
      color: selected ? t.activeText : t.textSecondary,
      background: selected ? t.activeBg : "transparent",
    }}
    onMouseEnter={(e) => {
      if (!selected) e.currentTarget.style.background = t.dropHover;
    }}
    onMouseLeave={(e) => {
      if (!selected) e.currentTarget.style.background = "transparent";
    }}
  >
    {Icon && (
      <Icon
        size={13}
        style={{
          opacity: selected ? 0.9 : 0.5,
          flexShrink: 0,
          color: selected ? t.activeText : undefined,
        }}
      />
    )}
    <span className="truncate">{children}</span>
  </button>
);
